import { render, staticRenderFns } from "./trocarsenha.vue?vue&type=template&id=6d90c6f0"
import script from "./trocarsenha.vue?vue&type=script&lang=js"
export * from "./trocarsenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports